import request from '@/utils/request'

export function findCpeGoods(params) {
  return request({
    url: `/customer/cpe_goods`,
    method: 'get',
    params
  })
}

export function findCpeGoodsInfo(id, params) {
  return request({
    url: `/customer/cpe_goods/${id}`,
    method: 'get',
    params
  })
}
